import { defineMessages } from "react-intl"

export default defineMessages({
  cancel: {
    defaultMessage: "Cancel",
    id: "src.components.TripCard.cancel",
  },
  currentTrip: {
    defaultMessage: "Current Trip",
    id: "src.components.MyTrips.currentTrip",
  },
  endDate: {
    defaultMessage: "End Date: ",
    id: "src.components.TripCard.endDate",
  },
  endTime: {
    defaultMessage: "End Time: ",
    id: "src.components.TripCard.endTime",
  },
  id: {
    defaultMessage: "ID: ",
    id: "src.components.TripCard.id",
  },
  license: {
    defaultMessage: "License: ",
    id: "src.components.TripCard.license",
  },
  noCurrentTrip: {
    defaultMessage: "No Current Trip",
    id: "src.components.MyTrips.noCurrentTrip",
  },
  noPastTrips: {
    defaultMessage: "No Past Trips",
    id: "src.components.MyTrips.noPastTrips",
  },
  noUpcomingTrips: {
    defaultMessage: "No Upcoming Trips",
    id: "src.components.MyTrips.noUpcomingTrips",
  },
  pastTrips: {
    defaultMessage: "Past Trips",
    id: "src.components.MyTrips.pastTrips",
  },
  startDate: {
    defaultMessage: "Start Date: ",
    id: "src.components.TripCard.startDate",
  },
  startLocation: {
    defaultMessage: "Start Location: ",
    id: "src.components.TripCard.startLocation",
  },
  startTime: {
    defaultMessage: "Start Time: ",
    id: "src.components.TripCard.startTime",
  },
  station: {
    defaultMessage: "Station: ",
    id: "src.components.TripCard.station",
  },
  upcomingTrips: {
    defaultMessage: "Upcoming Trips",
    id: "src.components.MyTrips.upcomingTrips",
  },
})
